export default __webpack_public_path__ + "static/media/atul_thakkar.ca532f83.jpeg";